<template>
  <div class="d-flex pl-1">
    <div class="d-flex align-start">
      <span class="body-2" style="margin-top: 5px; margin-right: 1px;">$</span>
      <span class="font-weight-bold text-h5">{{ dollar }}</span>
      <span class="body-2" style="margin-left: 2px; margin-top: 5px;">{{ cents }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ThePrice',
  props: {
    price: {
      type: String,
      default: ''
    }
  },
  computed: {
    dollar: function () {
      if (this.price) { return this.price.split('.')[0]; }
      return '';
    },
    cents: function () {
      if (this.price) { return this.price.split('.')[1]; }
      return '';
    }
  }
};
</script>
